import PersistenceRegistry from '../base/redux/PersistenceRegistry';
import ReducerRegistry from '../base/redux/ReducerRegistry';
import { SET_DEEPAI_THEME } from './actionTypes';
import { DEFAULT_THEME, STORE_NAME } from './constants';
const DEFAULT_STATE = {
    theme: DEFAULT_THEME
};
// Persist the selected theme across reloads.
PersistenceRegistry.register(STORE_NAME, true, DEFAULT_STATE);
ReducerRegistry.register(STORE_NAME, (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_DEEPAI_THEME:
            return {
                ...state,
                theme: action.theme
            };
        default:
            return state;
    }
});
